<template>
    <div class="table-responsive">
        <table class="table table-striped table-bordered table-hover" v-if="Object.keys(list).length">
            <thead class="bg-white">
                <tr>
                    <th class="w-50">ファイル名</th>
                    <th>サイズ</th>
                    <th>行動履歴(ファイル)</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(file, index) in list">
                    <td class="file_title">{{ file.title }}</td>
                    <td class="file_size">{{ file.size }}</td>
                    <td class="file_code">
                        <input type="text" :value="file.code" readonly>
                    </td>
                    <td class="file_act">
                        <input type="button"
                               class="btn btn-outline-danger btn-sm px-3"
                               value="削除"
                               v-if="isDelete"
                               @click="remove(index, file.code, file.title)">
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="text-danger small mb-3" v-if="Object.keys(list).length">
            <p class="m-0">*行動履歴(ファイル)のコードを本文に貼り付けメールを送信すると、このコードは受信メール本文では行動履歴取得URLに変換されます</p>
	 	    <p class="m-0">*メールを受信した見込みユーザーがこのURLからファイルダウンロードをすると、行動履歴(ファイル)を取得することが可能になります</p>
        </div>
        <div v-else>
            登録されていません。
            <p class="text-danger small m-0">*ファイルアップロードすると行動履歴(ファイル)のコードが表示されます</p>
        </div>
    </div>
</template>

<style>
.dropzone .dz-preview {
    width: 120px;
}
.dropzone .dz-preview .dz-error-message {
    top: 150px
}

.dropzone .dz-error-mark svg {
    background: darkred;
    border-radius: 30px;
}
</style>

<script>
import Dropzone from "dropzone";
import "dropzone/dist/dropzone.css";
import axios from "axios";

Dropzone.autoDiscover = false;

export default {
    props: {
        files: Array,
        templateId: Number,
        adminUserId: Number,
        isDelete: Boolean
    },
    data() {
        return {
            dropzone: null,
            list: [],
            values: [],
        };
    },
    mounted() {
        this.list = this.files;
        $('.js_dl_files').val(JSON.stringify(this.list));

        this.dropzone = new Dropzone("#file-upload", {
            url: "/api/file/upload",
            parallelUploads: 1,
            maxFilesize: 1024 * 10,
            filesizeBase: 1024,
            createImageThumbnails: false,
            addRemoveLinks: true,
            dictDefaultMessage: "ここをクリックかファイルをドラッグ&ドロップでアップロード",
            dictCancelUpload: "アップロードをキャンセル",
            dictRemoveFile: "操作エリアから削除",
        });

        this.dropzone.on("sending", (file, xhr, formData) => {
            if(this.templateId > 0) {
                formData.append('template_id', this.templateId);
            }
            if(this.adminUserId > 0) {
                formData.append('admin_user_id', this.adminUserId);
            }

        });

        this.dropzone.on("addedfile", file => {
            // console.log(`File added: ${file.name}`);
        });

        this.dropzone.on("success", (file, response) => {
            // console.info(file, response);
            this.list.push({
                title: response.name,
                size: response.size,
                code: response.code
            });
            $('.js_dl_files').val(JSON.stringify(this.list));
        });

        this.dropzone.on("error", (file, response) => {
            // console.error(file, response);
            file.previewTemplate.getElementsByClassName("dz-error-message")[0].textContent = "アップロードに失敗しました。";
        });

        this.dropzone.on("complete", file => {
        });

    },
    methods: {
        remove(index, code, name) {
            let delete_confirm_text = name + "を削除しますか？\n(メール本文中のコード削除漏れにご注意ください)";
            if(confirm(delete_confirm_text)){
                axios.post('/api/file/delete', {
                    code: code,
                    name: name,
                }).then((results) => {
                    // console.log(results);
                    this.list.splice(index, 1);
                    $('.js_dl_files').val(JSON.stringify(this.list));
                });
            }
        }
    }
}
</script>
